import { InfoLabel, Stage } from './interfaces'

export const useState = (): AppState => {
  return {
    stage: undefined,
    pdf: '',
    bosysReference: null,
    startupMessage: '',
    infoLabel: null
  }
}

export interface AppState {
  stage: Stage
  pdf: string
  bosysReference: string | null
  startupMessage: string
  infoLabel: InfoLabel | null
}